import { openBlock, createElementBlock, createElementVNode } from "vue";
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {
  name: "uikit-add-link-icon"
};
const _hoisted_1 = {
  width: "30",
  height: "16",
  viewBox: "0 0 30 16",
  fill: "currentColor",
  stroke: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", { d: "M24.7063 12.084H21.9138V10.5037H24.7063V7.68962H26.2865V10.5037H29.079V12.084H26.2865V14.862H24.7063V12.084Z" }, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.6875 0.5H18.75C21.9389 0.5 24.5779 2.90105 24.954 5.9901C24.4979 5.83445 24.0088 5.75 23.5 5.75C23.3364 5.75 23.1748 5.75874 23.0156 5.77577C22.5715 3.83089 20.8274 2.375 18.75 2.375H14.6875C14.1699 2.375 13.75 1.95508 13.75 1.4375C13.75 0.919922 14.1699 0.5 14.6875 0.5ZM19.0826 11.1125C18.9728 11.1208 18.8619 11.125 18.75 11.125H14.6875C14.1699 11.125 13.75 11.5449 13.75 12.0625C13.75 12.5801 14.1699 13 14.6875 13H18.75C19.1298 13 19.5018 12.9659 19.8632 12.9007C19.4819 12.3785 19.2104 11.7712 19.0826 11.1125ZM6.25 11.125H10.3125C10.8301 11.125 11.25 11.5449 11.25 12.0625C11.25 12.5801 10.8301 13 10.3125 13H6.25C2.80395 13 0 10.1961 0 6.75C0 3.30395 2.80395 0.5 6.25 0.5H10.3125C10.8301 0.5 11.25 0.919922 11.25 1.4375C11.25 1.95508 10.8301 2.375 10.3125 2.375H6.25C3.83789 2.375 1.875 4.33789 1.875 6.75C1.875 9.16211 3.83789 11.125 6.25 11.125ZM8.4375 7.6875C7.91992 7.6875 7.5 7.26758 7.5 6.75C7.5 6.23242 7.91992 5.8125 8.4375 5.8125H16.5625C17.0801 5.8125 17.5 6.23242 17.5 6.75C17.5 7.26758 17.0801 7.6875 16.5625 7.6875H8.4375Z"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
const uikitAddLinkIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  uikitAddLinkIcon as default
};
//# sourceMappingURL=uikit-add-link-icon.vue.es.js.map
